import WidgetModule from "@eisinc/Overrides/Widgets/Common/HeaderShipToAddress";

export * from "@eisinc/Overrides/Widgets/Common/HeaderShipToAddress";

export default WidgetModule;
